type Organization = {
  name: string;
  logo: string;
  url: string;
  description: string;
  domain?: string;
}

type WebPage = {
  title: string;
  description: string;
  url?: string;
  domain?: string;
  path?: string;
  datePublished?: string;
  dateModified?: string;
}

const getFullUrl = (domain: string, path: string = '') => {
  const baseUrl = domain.startsWith('http') ? domain : `https://${domain}`;
  return `${baseUrl}${path}`;
};

export const generateOrganizationSchema = (org: Organization) => {
  const url = org.domain ? getFullUrl(org.domain) : org.url;
  const logo = org.logo.startsWith('http') ? org.logo : getFullUrl(org.domain || '', org.logo);

  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: org.name,
    logo,
    url,
    description: org.description
  };
};

export const generateWebPageSchema = (page: WebPage) => {
  const url = page.domain ? getFullUrl(page.domain, page.path) : page.url;

  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: page.title,
    description: page.description,
    url,
    datePublished: page.datePublished,
    dateModified: page.dateModified
  };
};

export const generateContactPageSchema = (domain: string) => {
  const url = getFullUrl(domain, '/contact');

  return {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    url,
    name: 'Contact Us',
    description: 'Get in touch with us'
  };
}; 